module.exports = {"feature":{"aide":{"HOW_IT_WORKS":{"EBON":{"STEP2_CASHBACK_DISCOUNT":"<strong><span>{0} me {1}</span> sous 24h </strong> une partie de mon achat dans ma cagnotte."}}}}}


//////////////////
// WEBPACK FOOTER
// ./src/services/i18n/json/117.json
// module id = 1052
// module chunks = 0